import {sprintf} from "sprintf-js";

const isInt = (value) => {
    return !Number.isNaN(parseInt(value));
};

/**
 * Get array of entries that Integral keys. All keys for checklist items are Ints, so we use this to filter out
 * values that won't affect the passing or failing of the overall inspection.
 * @param object
 * @returns {[string, unknown][]}
 */
const arrayOfInts = (object) => {
    return Object.entries(object).filter((entry) => (isInt(entry[0])));
}

/**
 * Assuming all checklist items have keys of the form w.x.y.z...didPass find all "didPass" values and return them in
 * an array.
 * @param value
 * @param parent
 * @returns {({didPass}|*|({didPass}|*|{})[]|{})[]|{}|{didPass}|*}
 */
const getDidPassLeaves = (value, parent) => {
    if (typeof value === "object") {
        if (value.hasOwnProperty("didPass")) {
            return { "parent": parent, didPass: value["didPass"], comment: value["comment"]};
        }
        return arrayOfInts(value).map(entry => (getDidPassLeaves(entry[1], !!parent ? parent + "." + entry[0]: entry[0])));
    }
    return {};
}

const failCommentSummary = (content) => {
    const comments = getDidPassLeaves(content, "").flat(3).map((entry) => {
        if (!entry.didPass) {
            if (entry.comment.length) {
                return sprintf("%s: %s", entry.parent, entry.comment.trim());
            }
        }
        return undefined;
    });
    return comments.filter(n => n).join(" ");
}

export default getDidPassLeaves;
export {failCommentSummary};